import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { Button, Icon } from '../common';

export function SsoInterapyGradingButton(props: { request: IRequestGetOne; ssoToInterapy?: () => Promise<void> }) {
    if (
        !props.request.authorization ||
        !props.request.authorization.canAddExaminationDiagnosticReport ||
        !props.ssoToInterapy
    ) {
        return null;
    }

    return (
        <Button
            color="secondary"
            large
            onClick={props.ssoToInterapy}
        >
            <Icon icon="external" /> Beoordeel onderzoek
        </Button>
    );
}
